<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <ubraniaMenu></ubraniaMenu>
        <div class="widget-heading">
          <div class="row mb-2">
            <div class="col-12 d-flex flex-wrap gap-2">
              <div class="flex-fill d-flex" style="min-width: 300px;">
                <select v-model="selectedDepartament" class="form-select w-100" @change="loadData">
                  <option value="0">WSZYSTKIE DZIAŁY</option>
                  <option v-for="department in departaments" :key="department.id" :value="department.id">
                    {{ department.name }}
                  </option>
                  <option value="-1">POZOSTALI PRACOWNICY</option>
                </select>
              </div>
              <div class="flex-fill d-flex" style="min-width: 300px;">
                <select v-model="selectedTyp" class="form-select w-100" @change="loadData">
                  <option v-for="typ in typy" :key="typ.id" :value="typ.id">{{ typ.nazwa }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
              <tr>
                <th class="bg-gray-100 text-start">#</th>
                <th class="bg-gray-100 text-start" @click="sortBy('userName')" style="cursor:pointer">
                  Pracownik
                  <span v-if="sortKey === 'userName'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th v-for="(g, index) in grupy"
                    :key="g.id"
                    class="bg-gray-100 text-center"
                    :draggable="true"
                    @dragstart="dragStart(index)"
                    @dragover.prevent
                    @drop="drop(index)"
                    style="position: relative; cursor: grab;">
                    <span @click="sortBy(g.id)" style="cursor: pointer;">
                      {{ g.nazwa }}
                      <span v-if="sortKey === g.id"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                    </span>
                </th>
                <th class="bg-gray-100 text-center">Dodatkowe informacje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, i) in filteredAndSortedUsers" :key="user.userId">
                <td style="width: 15px;">{{ i + 1 }}</td>
                <td class="text-start" :style="user.position == 'Uczeń' ? 'background-color: #37d96d;' : ''">
                  <Link :href="route('bhp.ubrania.show.user', user.userId)" class="text-primary" style="cursor:pointer">
                    {{ user.userName }} <span v-if="user.position == 'Uczeń'">(Uczeń)</span>
                  </Link>
                </td>

                <!-- POPRAWIONE: iteracja po grupach wg kolejności nagłówków -->
                <td v-for="(g, index) in grupy" :key="g.id" class="text-center align-top"
                    @click="openModal(user.userId, g.id)"
                    :style="{
                        backgroundColor: (() => {
                          const gr = user.grupy.find(grp => grp.grupa_id === g.id);
                          const dni = gr?.dane?.[0]?.data_wydania
                            ? dniDoWymiany(gr.dane[0].data_wydania, gr.dane[0].wymiana).dni
                            : null;
                          if (dni !== null && dni < 90) return 'red';
                          return user.position == 'Uczeń' ? '#37d96d' : '';
                        })(),
                        color: (() => {
                          const gr = user.grupy.find(grp => grp.grupa_id === g.id);
                          const dni = gr?.dane?.[0]?.data_wydania
                            ? dniDoWymiany(gr.dane[0].data_wydania, gr.dane[0].wymiana).dni
                            : null;
                          if (dni !== null && dni < 90) return 'white';
                          return '';
                        })(),
                        cursor: 'pointer'
                      }"
                >
                  <div v-if="user.grupy.find(grp => grp.grupa_id === g.id)?.dane?.length > 0">
                    <div v-for="art in user.grupy.find(grp => grp.grupa_id === g.id).dane" :key="art.artykul_id"
                         class="mt-1">
                      <div v-html="art.wymiana
                          ? `${formatDate(art.data_wydania)} (${dniDoWymiany(art.data_wydania, art.wymiana).dni} dni) ${dniDoWymiany(art.data_wydania, art.wymiana).ikona}`
                          : art.data_wydania"
                      ></div>
                      <small>{{ art.artykul }} ({{ art.rozmiar }})</small>
                    </div>
                  </div>
                </td>

                <td class="text-center" @click="openModalInfo(user)"
                    :style="{backgroundColor: user.position == 'Uczeń' ? '#37d96d' : '', cursor: 'pointer'}">
                  <span v-if="user.info">{{ user.info }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

<!-- MODALE (uproszczony select Bezterminowo) -->
<div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Dodawanie artykułu dla pracownika</h5>
        <button type="button" class="btn-close" @click="closeModal"></button>
      </div>
      <div class="modal-body">
        <!-- wybór artykułu -->
        <div class="mb-3">
          <label for="artykulSelect" class="form-label">Artykuł</label>
          <select v-model="selectedArtykulId" class="form-select">
            <option v-for="art in modalArtykuly" :key="art.key" :value="art.key" :disabled="art.disabled">
              {{ art.nazwa }} ({{ art.rozmiar }}) {{ art.stan === 0 ? '- brak na stanie' : '' }}
            </option>
          </select>
        </div>

        <!-- data wydania -->
        <div class="mb-3">
          <label for="dataWydania" class="form-label">Data wydania</label>
          <input type="date" v-model="selectedDate" class="form-control" id="dataWydania"/>
        </div>

        <!-- prosty select Bezterminowo Tak/Nie -->
        <div class="mb-2">
          <label>Czy Bezterminowo?</label>
          <select v-model.number="newItem.wymiana" class="form-select">
            <option :value="0">Nie</option>
            <option :value="1">Tak</option>
          </select>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" @click="closeModal">Zamknij</button>
        <button class="btn btn-success" @click="save">Zapisz</button>
      </div>
    </div>
  </div>
</div>

        <div v-if="isModalOpenInfo" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Dodatkowa informacja</h5>
                <button type="button" class="btn-close" @click="closeModalInfo"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <textarea v-model="selectedUserInfo" class="form-control" id="userInfo"></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeModalInfo">Zamknij</button>
                <button class="btn btn-success" @click="saveInfo">Zapisz</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import ubraniaMenu from "@/Pages/BHP/parts/ubraniaMenu.vue";
import axios from 'axios';

export default {
  components: {AppLayout, ubraniaMenu},
  props: {
    departaments: Array,
    typy: Array,
    typ: Number,
    rozmiary: Object,
  },
  data() {
    return {
      users: [],
      isModalOpen: false,
      isModalOpenInfo: false,
      selectedDepartament: 0,
      selectedTyp: this.typ ?? 1,
      sortKey: "userName",
      sortOrder: "desc",
      selectedUserId: null,
      selectedGrupaId: null,
      selectedArtykulId: null,
      selectedDate: new Date().toISOString().slice(0, 10),
      modalArtykuly: [],
      selectedArtykul: null,
      dragIndex: null,
 newItem: {
      wymiana: 0, // domyślnie Nie (czyli nochange = 0)
    },
    };
  },
  computed: {
    filteredAndSortedUsers() {
      return [...this.users].sort((a, b) => {
        let result = 0;
        if (this.sortKey === 'userName') {
          result = a.userName.localeCompare(b.userName);
        } else {
          const groupId = parseInt(this.sortKey);
          const aGroup = a.grupy.find(g => g.grupa_id === groupId);
          const bGroup = b.grupy.find(g => g.grupa_id === groupId);
          const aDate = aGroup?.dane?.[0]?.data_wydania ? new Date(aGroup.dane[0].data_wydania) : new Date(0);
          const bDate = bGroup?.dane?.[0]?.data_wydania ? new Date(bGroup.dane[0].data_wydania) : new Date(0);
          if (aDate > bDate) result = 1;
          if (aDate < bDate) result = -1;
        }
        return this.sortOrder === 'asc' ? result : -result;
      });
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pl-PL"); 
    },
    dniDoWymiany(dataWydania, wymiana) {
      if (!dataWydania || !wymiana) return {dni: null, ikona: ''};
      const wydanieDate = new Date(dataWydania);
      const today = new Date();
      const nextExchangeDate = new Date(wydanieDate);
      nextExchangeDate.setFullYear(wydanieDate.getFullYear() + parseInt(wymiana));
      const diffDays = Math.ceil((nextExchangeDate - today) / (1000 * 60 * 60 * 24));
      let ikona = '';
      if (diffDays < 0) ikona = '<span class="text-danger ms-1" title="Minął termin wydania odzieży">⚠️</span>';
      else if (diffDays < 60) ikona = '<span class="text-warning ms-1" title="Zbliża się termin wydania odzieży">⚠️</span>';
      return {dni: diffDays, ikona};
    },
    async openModalInfo(user) {
      this.selectedUserId = user.userId;
      this.selectedUserInfo = user.info || '';
      this.isModalOpenInfo = true;
    },
    closeModalInfo() {
      this.isModalOpenInfo = false;
      this.selectedUserId = null;
      this.selectedUserInfo = '';
    },
    async saveInfo() {
      if (!this.selectedUserId) return;
      try {
        await axios.post(route("bhp.user-info.update"), {user_id: this.selectedUserId, info: this.selectedUserInfo});
        const user = this.users.find(u => u.userId === this.selectedUserId);
        if (user) user.info = this.selectedUserInfo;
        this.closeModalInfo();
        this.showToast('success', 'Sukces', 'Informacja została zaktualizowana.');
      } catch (e) {
        console.error(e);
        this.showToast('error', 'Błąd', 'Nie można zapisać informacji!');
      }
    },
    async openModal(userId, grupaId) {
      this.selectedUserId = userId;
      this.selectedGrupaId = grupaId;
      this.isModalOpen = true;
      this.selectedDate = new Date().toISOString().slice(0, 10);
      try {
        const response = await axios.get(route("bhp.ubrania.pobierz-artykuly"), {
          params: {
            user_id: userId,
            grupa_id: grupaId
          }
        });
        this.modalArtykuly = response.data.artykuly.flatMap(a => a.rozmiary.map(r => ({
          key: `${a.id}-${r.id}`,
          artykul_id: a.id,
          nazwa: a.nazwa,
          opis: a.opis,
          wymiana: a.wymiana,
          rozmiar_id: r.id,
          rozmiar: r.nazwa,
          stan: r.stan,
          disabled: r.disabled
        })));
        const userArtykuly = response.data.userArtykuly ?? [];
        if (userArtykuly.length > 0) {
          const current = this.modalArtykuly.find(m => m.artykul_id === userArtykuly[0].artykul_id && m.rozmiar_id === userArtykuly[0].rozmiar_id);
          if (current) {
            this.selectedArtykulId = current.key;
            this.selectedDate = userArtykuly[0].data_wydania;
          }
        } else this.selectedArtykulId = null;
      } catch (e) {
        console.error(e);
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedUserId = null;
      this.selectedGrupaId = null;
      this.selectedArtykulId = null;
      this.modalArtykuly = [];
    },
async save() {
  if (!this.selectedArtykulId) {
    this.showToast('error', 'Błąd', 'Wybierz artykuł i rozmiar!');
    return;
  }

  const [artykulId, rozmiarId] = this.selectedArtykulId.split("-");

  try {
    await axios.post(route("bhp.terminy.ubrania.store"), {
      user_id: this.selectedUserId,
      grupa_id: this.selectedGrupaId,
      artykul_id: artykulId,
      rozmiar_id: rozmiarId,
      data_wydania: this.selectedDate,
     wymiana: this.newItem.wymiana,
    });

    this.closeModal();
    this.loadData();
    this.showToast('success', 'Sukces', 'Artykuł poprawnie dodany.');
  } catch (e) {
    console.error(e);
    this.showToast('error', 'Błąd', 'Nie udało się dodać artykułu!');
  }
},
    async loadData() {
      try {
        const response = await axios.get(route("bhp.terminy.ubrania.pracownikow"), {
          params: {
            departament: this.selectedDepartament,
            typ: this.selectedTyp
          }
        });
        this.users = response.data.users || [];
        this.grupy = response.data.grupy.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
        this.users.forEach(user => {
          user.grupy = (user.grupy || []).map(gr => {
            let dane = gr.dane;
            if (dane && !Array.isArray(dane)) dane = Object.values(dane);
            return {...gr, dane: dane || []};
          });
        });
      } catch (e) {
        console.error(e);
      }
    },
    sortBy(key) {
      this.sortKey === key ? this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc' : (this.sortKey = key, this.sortOrder = 'asc');
    },
    dragStart(index) {
      this.dragIndex = index;
    },

    drop(dropIndex) {
      if (this.dragIndex === null || this.dragIndex === dropIndex) return;
      const draggedItem = this.grupy[this.dragIndex];
      this.grupy.splice(this.dragIndex, 1);
      this.grupy.splice(dropIndex, 0, draggedItem);
      this.grupy.forEach((g, i) => g.position = i + 1);
      this.users = [...this.users];
      this.saveGroupPositions();
      this.dragIndex = null;
    },
    async saveGroupPositions() {
      try {
        await axios.post(route("bhp.grupy.update-positions"), {
          grupy: this.grupy.map(g => ({
            id: g.id,
            position: g.position
          }))
        });
        this.showToast('success', 'Sukces', 'Kolejność grup została zapisana.');
      } catch (e) {
        console.error(e);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać kolejności grup.');
      }
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon,
        title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>


<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}

.table tbody tr:nth-child(even) td:not([style*="background-color"]) {
  background-color: #f9f9f9 !important;
}

.table tbody tr:nth-child(odd) td:not([style*="background-color"]) {
  background-color: #ffffff !important;
}

/* hover nadal działa, ale tylko na niekolorowanych komórkach */
.table tbody tr:hover td:not([style*="background-color"]) {
  background-color: #eaeaea !important;
}
</style>
